import React from "react";
import {StaticFieldDisplayProps} from "../staticFieldUtils.ts";
import {STATIC_RENDER_COMPONENTS, STATIC_RENDER_TYPE} from "../../../DynamicFormTypes.ts";



const StaticComponentDisplayRenderer: React.FC<StaticFieldDisplayProps> = ({ value }) => {

    let enumValue: STATIC_RENDER_TYPE;
    try {
        enumValue= value as STATIC_RENDER_TYPE;
    }
    catch (error) {
        console.error("Invalid component type", error);
        return null;
    }

    const StaticComponent = STATIC_RENDER_COMPONENTS[enumValue];

    return <StaticComponent />
};

export const StaticComponentDisplay = React.memo(StaticComponentDisplayRenderer);